export const STORAGE_KEY = 'jwm.sidebar';
export const SIDEBAR_MIN_WIDTH = 463;
